import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";

import { Post } from "./post";
import { IPost } from "../../models/post.model";
import { IAuthor } from "../../models/author.model";
import { ISite } from "../../models/site.model";
import { config } from "../../config";

interface IPreviewResponse {
    post: IPost;
    author: IAuthor;
    authors: IAuthor[];
}

const PostPreviewPage: React.FC<{ data: { site: ISite } }> = ({ data: { site } }) => {
    const [preview, setPreview] = useState<IPreviewResponse | null>(null);
    const [error, setError] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const expires = params.get("expires");
        const signature = params.get("signature");

        if (!id || !expires || !signature) {
            setError("Nieprawidłowy link podglądu.");
            return;
        }

        fetch(
            `${config.baseUrl}/post-preview/${encodeURIComponent(id)}` +
                `?expires=${encodeURIComponent(expires)}` +
                `&signature=${encodeURIComponent(signature)}`
        )
            .then(response => {
                if (!response.ok) {
                    throw new Error("Nie udało się pobrać podglądu posta.");
                }
                return response.json();
            })
            .then((data: IPreviewResponse) => setPreview(normalizePreview(data)))
            .catch(reason => setError(reason.message));
    }, []);

    if (error) {
        return <main style={{ padding: "48px", fontFamily: "sans-serif" }}>{error}</main>;
    }
    if (!preview) {
        return <main style={{ padding: "48px", fontFamily: "sans-serif" }}>Ładowanie podglądu...</main>;
    }

    return (
        <Post
            pageContext={{} as any}
            data={{
                post: preview.post,
                author: preview.author,
                authors: { edges: preview.authors.map(node => ({ node })) },
                promotedPosts: { edges: [] },
                allRelatedPosts: {
                    edges: (preview.post.relatedPosts || []).map(node => ({ node })),
                },
                site,
            }}
        />
    );
};

function normalizePreview(data: IPreviewResponse): IPreviewResponse {
    const apiUrl = config.baseUrl || "https://api-fashionfairy.ddns.net";
    const normalizeUrl = (url?: string) =>
        url
            ? url
                  .replace(/^https?:\/\/(api\.)?fashionfairy\.pl/i, apiUrl)
                  .replace(/\?r=file%2Ffile%2Fget&id=/, "/get-file/")
            : url;
    const normalizeMedia = (media: any[] = []) =>
        media.map(item => ({ ...item, url: normalizeUrl(item.url) }));
    const translations = { ...data.post.translations };

    Object.keys(translations).forEach(language => {
        const translation = translations[language];
        translations[language] = {
            ...translation,
            content: translation.content
                ? translation.content.replace(
                      /https?:\/\/(api\.)?fashionfairy\.pl/gi,
                      apiUrl
                  )
                : translation.content,
        };
    });

    return {
        post: {
            ...data.post,
            translations,
            media: normalizeMedia(data.post.media),
        },
        author: {
            ...data.author,
            media: normalizeMedia(data.author?.media),
        },
        authors: (data.authors || []).map(author => ({
            ...author,
            media: normalizeMedia(author.media),
        })),
    };
}

export default PostPreviewPage;

export const query = graphql`
    query PostPreviewPageQuery($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        site {
            siteMetadata {
                title
                url
                image
                description
            }
        }
    }
`;
